import {useCallback, useEffect, useState} from 'react';

const getIsActive = () =>
  document.visibilityState === 'visible' && document.hasFocus();

export const useIsTabActive = () => {
  const [visibilityState, setVisibilityState] = useState(getIsActive);

  const handleChange = useCallback(() => {
    setVisibilityState(getIsActive());
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleChange);
    window.addEventListener('focus', handleChange);
    window.addEventListener('blur', handleChange);
    return () => {
      document.removeEventListener('visibilitychange', handleChange);
      window.removeEventListener('focus', handleChange);
      window.removeEventListener('blur', handleChange);
    };
  }, [handleChange]);

  return visibilityState;
};
